export default __webpack_public_path__ + "static/0137-3293d73d383e865942a16695327ff76f.png";